import styled from 'styled-components'

export const Container = styled.div`
  position: relative;
  padding-top: 56.25%;

  > div {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 25%;
  }

  .player {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
`
